import { render, staticRenderFns } from "./exact-auth-link.vue?vue&type=template&id=4d8e0550&scoped=true&"
import script from "./exact-auth-link.ts?vue&type=script&lang=ts&"
export * from "./exact-auth-link.ts?vue&type=script&lang=ts&"
import style0 from "./exact-auth-link.scss?vue&type=style&index=0&id=4d8e0550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e0550",
  null
  
)

export default component.exports